import { CircularProgress } from "@material-ui/core";
import PDFViewer from "mgr-pdf-viewer-react";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import "./work-file.css";
import "./iframeStyle.css";
import { setTimeout } from "timers";
import { API_ENDPOINT, callApi } from "../../utils/api";
import { ADMIN_ROLE, FRONTOFFICE_ROLE, MANAGER_ROLE } from "../../utils/role";
import ReactFileReader from "react-file-reader";
import { saveAs } from "file-saver";
import { notifyToUser } from "../../utils/firebase";
import moment from "moment";
import { pushnotificationApi } from "../../utils/pushNotify";
import CountdownTimer from "../file/CountdownTimer";
import TabKeyBlocker from "../Customecomponent/TabKeyBlocker";
import DocumentVerificationPanel from "../DocumentVerification/DocumentVerificationPanel";
import { getAiWorkflowStatus, AI_RESUBMIT_REQUIRED_COMPLETE_MESSAGE, AI_NO_RUN_COMPLETE_MESSAGE, AI_VERIFICATION_IN_PROGRESS_COMPLETE_MESSAGE, AI_RERUN_VERIFICATION_COMPLETE_MESSAGE, isAiRunActionResubmitRequired, isAiLatestRunMissing, isAiVerificationStatusNeedsRerun, getAiWorkflowPayload, isAiWorkFileScreenEnabled, pickLatestRunForProcess, resolveProcessTypeForCompleteGate, getAiCompleteFileBlock } from "../../utils/aiDocumentVerification";
import {
  clearDocGenTimeout,
  extractAxiosDocGenError,
  isDocGenFailedResponse,
  isDocGenQueued,
  docGenFailureMessage,
  releaseDocGenClickFreeze,
  pollGeneratedDocx,
  DOC_GEN_TIMEOUT_SEC,
  failWithDocGenTimeout,
  isDocGenWorkerDownError,
  watchDocGenWorkerUntilUp,
  isDocGenWorkerRunning,
  DOC_GEN_WORKER_DOWN_MESSAGE,
} from "../../utils/docGenerationTimeout";

declare var $: any;
interface AllProps {
  id: any;
  isFinal: boolean;
  history: any;
  fileId: any;
}
export default class Overview extends Component<AllProps> {
  state = {
    showTitle: true,
    isComplete: true,
    report: "",
    rep_id: "",
    remote_users: [],
    isapproved: 0,
    office_users: [],
    responseURL: "",
    pdfPreview: "",
    realFileidfk: "",
    file: "",
    pdfurl: "",
    enableRefresh: true,
    isApprove: false,
    isVerify: false,
    action: "",
    reason: "",
    uploadFile: {
      base64: "",
      fileList: [{ name: "" }],
    },
    updateDownloadData: {
      reasonForDownload: [],
      updatedDetails: [],
    },
    lastUploadedDocument: {
      pdf: null,
      docx: null,
    },
    timer: 0,
    blockdownload: "",
    isLoading: false,
    filestatus: "",
    takenStatus: "",
    vtakenStatus: "",
    rtakenStatus: "",
    isrectificationComplete: true,
    fileNotCompleteMsg: { __html: "" },
    serverLocalFileName: "",
    fileOpinionType: "",
    processChecklistStatus: false,
    documentDocPath: "",
    documentEmbedUrl: "",
    aiPendingErrors: 0,
    aiCanComplete: true,
    aiVerificationEnabled: false,
    aiLatestRunAction: "",
    aiLatestRunNoRecord: false,
    aiLatestRunVerificationStatus: "",
    generationTimedOut: false,
    generationError: "",
    workFileUploaded: false,
  };
  intervalId: NodeJS.Timeout | null = null;
  pollTimeoutId: any = null;
  generationTimeoutTriggered: boolean = false;
  stopWorkerWatch: (() => void) | null = null;
  rendered: any;
  componentDidMount() {
    const fileKey = this.props.id || this.props.fileId;
    clearDocGenTimeout(fileKey);
    this.generationTimeoutTriggered = false;
    this.blockdownload();
    this.getFiles();
    if (this.props.isFinal) {
      this.getUsers();
    }
    this.checkApproveVerify();
    this.loadAiWorkflowStatus();
    this.getUpdateReasonData();
    this.getFileOverview();
    this.intervalId = setInterval(() => {
      this.incrementTimer();
    }, 1000);
  }
  componentWillUnmount() {
    this.stopPollingAndTimer();
    this.stopWorkerWatch?.();
    this.stopWorkerWatch = null;
    releaseDocGenClickFreeze();
  }

  startTimer() {
    this.intervalId = setInterval(() => {
      this.incrementTimer();
    }, 1000);
  }
  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
  stopPollingAndTimer = () => {
    this.stopTimer();
    if (this.pollTimeoutId) {
      clearTimeout(this.pollTimeoutId);
      this.pollTimeoutId = null;
    }
  };
  handleGenerationFailure = (detail: string) => {
    this.stopPollingAndTimer();
    this.generationTimeoutTriggered = true;
    releaseDocGenClickFreeze();
    const error = (detail || "Document generation failed.").trim();
    clearDocGenTimeout(this.props.id || this.props.fileId);
    try {
      localStorage.removeItem("overviewDocument");
    } catch (e) {}
    this.setState({
      generationTimedOut: true,
      generationError: error,
      enableRefresh: false,
    });
    try {
      ToastsStore.error(error);
    } catch (e) {}
    if (isDocGenWorkerDownError(error)) {
      this.stopWorkerWatch?.();
      this.stopWorkerWatch = watchDocGenWorkerUntilUp(() => {
        this.retryDocumentGeneration();
      });
    }
  };
  retryDocumentGeneration = () => {
    this.stopWorkerWatch?.();
    this.stopWorkerWatch = null;
    clearDocGenTimeout(this.props.id || this.props.fileId);
    this.generationTimeoutTriggered = false;
    releaseDocGenClickFreeze();
    this.setState(
      {
        generationTimedOut: false,
        generationError: "",
        timer: 0,
        enableRefresh: false,
      },
      () => {
        this.startTimer();
        this.scrutinyReport();
      },
    );
  };
  incrementTimer = () => {
    if (this.state.generationTimedOut || this.state.report) {
      return;
    }
    this.setState(
      (prevState: any) => ({
        timer: prevState.timer + 1,
      }),
      () => {
        if (
          this.state.timer >= DOC_GEN_TIMEOUT_SEC &&
          !this.state.generationTimedOut &&
          !this.state.report &&
          !this.generationTimeoutTriggered
        ) {
          failWithDocGenTimeout((message) =>
            this.handleGenerationFailure(message),
          );
        }
      },
    );
  };
  getFiles = () => {
    callApi("POST", "search.php", {
      file_name: this.props.id,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response["data"] && response["data"][0]) {
          const filestatus = response["data"][0].file_status;
          const fileOpinionType = response["data"][0].opinion_type;
          const processChecklistStatus =
            response["data"][0].process_checklist_status;
          this.setState({
            filestatus,
            fileOpinionType,
            processChecklistStatus,
            takenStatus: response["data"][0].taken_status ?? "",
            vtakenStatus: response["data"][0].vtaken_status ?? "",
            rtakenStatus: response["data"][0].rtaken_status ?? "",
          }, () => {
            this.loadAiWorkflowStatus();
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  blockdownload = () => {
    callApi("POST", "block_download_status.php", {
      file_idfk: this.props.id,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({
          blockdownload: response["responseJson"].data[0].block_download_status,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getFileOverview = () => {
    callApi("POST", "final_report_get.php", {
      file_idfk: this.props.id,
      check: false,
    })
      .then((res) => res.data)
      .then((response) => {
        let realFileidfk = response.data[0].file_idfk;

        this.setState({
          realFileidfk: 0,
        });
        this.delaylaoding(realFileidfk);
        if (response.data[0].file_idfk !== null) {
          callApi(
            "POST",
            "print_preview.php?id=" + response.data[0].file_idfk,
            0,
          )
            .then((res) => res.data)
            .then((response) => {
              let previewURL = response.data;
              let previewEcho = API_ENDPOINT + "api/" + previewURL;

              let pdfPreview = response.data[0].file_idfk;
              this.setState({
                pdfPreview,
              });
            });
        }
        var docOverview = localStorage.getItem("overviewDocument");
        if (this.props.id == localStorage.getItem("currentFile") && docOverview != null) {
          this.stopTimer();
          this.setState({ report: docOverview, enableRefresh: true });
          $("#root").unbind();
          releaseDocGenClickFreeze();
        } else {
          this.scrutinyReport();
        }
      })
      .catch((err) => {
        console.log(err);
        this.handleGenerationFailure(extractAxiosDocGenError(err));
      });
  };

  scrutinyReport = () => {
    if (this.state.generationTimedOut || this.generationTimeoutTriggered) {
      this.stopPollingAndTimer();
      return;
    }
    isDocGenWorkerRunning().then((running) => {
      if (this.state.generationTimedOut || this.generationTimeoutTriggered) {
        return;
      }
      if (running === false) {
        this.handleGenerationFailure(DOC_GEN_WORKER_DOWN_MESSAGE);
        return;
      }
      const user: any = localStorage.getItem("user");
      const userId = user ? JSON.parse(user)["userId"] : "";
      callApi("POST", "template/tests/scrutiny_report_zmq.php", {
        file_idfk: this.props.id || this.props.fileId,
        check: false,
        userId,
      })
        .then((res) => res.data)
        .then((response) => {
          if (isDocGenFailedResponse(response)) {
            this.handleGenerationFailure(docGenFailureMessage(response));
            return;
          }
          if (isDocGenQueued(response)) {
            localStorage.setItem("serverLocalFileName", response.local_file_name);
            this.setState({
              serverLocalFileName: response.local_file_name,
              documentDocPath: response.doc_path || "",
              documentEmbedUrl: response.data || "",
            });
            this.finalReport(response);
            return;
          }
          this.handleGenerationFailure(
            docGenFailureMessage(
              response,
              "Document generation did not start. Please try again.",
            ),
          );
        })
        .catch((err) => {
          console.log(err);
          this.handleGenerationFailure(extractAxiosDocGenError(err));
        });
    });
  };

  finalReport = (zmqresponse) => {
    pollGeneratedDocx({
      url: zmqresponse.doc_path,
      isCancelled: () =>
        this.state.generationTimedOut || this.generationTimeoutTriggered,
      onReady: () => {
        if (this.pollTimeoutId) {
          clearTimeout(this.pollTimeoutId);
          this.pollTimeoutId = null;
        }
        localStorage.setItem("overviewDocument", zmqresponse.data);
        var currentFile = zmqresponse.file_name.split("-");
        localStorage.setItem("currentFile", currentFile[1]);
        clearDocGenTimeout(this.props.id || this.props.fileId);
        this.stopTimer();
        this.setState({
          report: zmqresponse.data,
          enableRefresh: true,
          documentDocPath: zmqresponse.doc_path || this.state.documentDocPath,
          documentEmbedUrl: zmqresponse.data,
        });
        releaseDocGenClickFreeze();
      },
      onFailure: (message) => this.handleGenerationFailure(message),
      schedule: (fn, ms) => {
        this.pollTimeoutId = setTimeout(fn, ms);
      },
    });
  };

  delaylaoding = (realFileidfk) => {
    setTimeout(() => {
      this.setState({
        realFileidfk,
      });
    }, 10000);
  };
  resetOverview = () => {
    callApi("POST", "report_delete.php", { id: this.props.id })
      .then((res) => res.data)
      .then((response) => {
        ToastsStore.success("Reset success!");
        this.getFileOverview();
      });
  };
  downloadPDF = () => {
    const input: any = document.getElementById("report-content");
    let mywindow: any = window.open(
      "",
      "PRINT",
      "height=650,width=900,top=100,left=150",
    );
    mywindow.document.write(input.innerHTML);
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    mywindow.close();

    ToastsStore.success("Downloaded Successfully!");
    return true;
  };
  saveReport = (status) => {
    // const report: any = document.getElementById("report-content");
    const reportInput: any = this.state;
    const user: any = localStorage.getItem("user");
    reportInput.userId = user ? JSON.parse(user)["userId"] : "";
    // reportInput.report = report.innerHTML;
    reportInput.file_idfk = this.props.id;
    reportInput.status = status;
    delete reportInput.isapproved;
    delete reportInput.office_users;
    delete reportInput.remote_users;
    callApi("POST", "final_report.php", reportInput)
      .then((res) => res.data)
      .then((response) => {
        if (status === 0)
          ToastsStore.success("Saved & Submitted Successfully!");
        else ToastsStore.success("Saved Successfully!");
        this.getFileOverview();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getUsers = () => {
    callApi("POST", "office_details.php", {
      id: this.props.id,
    })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ office_users: response.data });
      });
  };

  getUpdateReasonData = () => {
    const reasonData: any = this.state.updateDownloadData;
    callApi("POST", "dashboard_log.php", { id: this.props.id })
      .then((res) => res.data)
      .then((result) => {
        let { lastUploadedDocument } = this.state;
        reasonData.reasonForDownload = result.data.reasonForDownload;
        // Object.keys(result.data[0][1]).map(key => result.data[0][1][key]);
        reasonData.updatedDetails = result.data.updatedDetails;
        if (reasonData.updatedDetails && reasonData.updatedDetails.length > 0) {
          lastUploadedDocument = reasonData.updatedDetails[0].url[0];
        }
        // result.data[0][0];
        this.setState({ updateDownloadData: reasonData, lastUploadedDocument });
      })
      .catch((err) => {
        console.log("Errororor", err);
        // ToastsStore.error("Failed to get ");
      });
  };

  hasWorkFileDocumentForVerification = (): boolean =>
    !!this.state.workFileUploaded;

  requiresWorkFileUploadDoc = (): boolean =>
    this.state.blockdownload == "false" || this.state.fileOpinionType != "1";

  getWorkFileDocxUrl = (): string => {
    const doc: any = this.state.lastUploadedDocument;
    if (!doc) return "";
    if (typeof doc === "string") return doc.trim();
    return String(doc.docx || doc.DOCX || "").trim();
  };

  //Download docs from external api
  downloadDocs = () => {
    const shownReport =
      this.state.report || localStorage.getItem("overviewDocument") || "";
    const srcMatch = String(shownReport).match(/[?&]src=([^&]+\.docx)/i);
    let reportDocx = "";
    if (srcMatch && srcMatch[1]) {
      try {
        reportDocx = decodeURIComponent(srcMatch[1]);
      } catch (e) {
        reportDocx = srcMatch[1];
      }
    }

    const { lastUploadedDocument } = this.state;
    const fileUrl = reportDocx || (lastUploadedDocument && lastUploadedDocument.docx);

    if (fileUrl) {
      callApi("POST", "get_branch_code.php", {
        id: this.props.id,
      })
        .then((res) => res.data)
        .then((response) => {
          const name = `${response.data[0].lawhands_branch}-${this.props.id}.docx`;
          saveAs(fileUrl, name);
        });
    } else {
      callApi("POST", "template/tests/shell.php", {
        id: this.props.id,
        responseType: "blob",
      })
        .then((res) => res.data)
        .then((response) => {
          //ToastsStore.success("Downloaded Successfully!");
          window.open(
            API_ENDPOINT + "template/tests/shell.php?id=" + this.props.id,
            "_self",
          );
        });
    }
  };

  selectUser = (e: any, user: any) => {
    const remote_users: any = this.state.remote_users;
    if (e.target.checked) {
      remote_users.push({ email: user.email, name: user.name });
    } else {
      remote_users.filter((itm) => itm.email !== user.email);
    }
    this.setState({ remote_users });
  };
  sendMail = () => {
    const mailInput: any = Object.create({});
    mailInput.fod_fk = this.props.id;
    mailInput.remote_users = this.state.remote_users;
    const user: any = localStorage.getItem("user");
    mailInput.user_idfk = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "report_mail.php", mailInput)
      .then((res) => res.data)
      .then((response) => { })
      .catch((err) => {
        console.log(err);
      });
  };
  approveFile = () => {
    const mailInput: any = Object.create({});
    mailInput.fod_fk = this.props.id;
    mailInput.status = this.state.isapproved ? 0 : 1;
    const user: any = localStorage.getItem("user");
    mailInput.user_idfk = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "report_approve.php", mailInput)
      .then((res) => res.data)
      .then((response) => {
        if (this.state.isapproved) ToastsStore.success("Reworked");
        else ToastsStore.success("Approved");
        this.getFileOverview();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onEditorChange(evt) {
    this.setState({
      report: evt.editor.getData(),
    });
  }
  loadAiWorkflowStatus = () => {
    const processType = resolveProcessTypeForCompleteGate("work-file", this.state.filestatus);
    getAiWorkflowStatus(this.props.id, processType)
      .then((response) => {
        if (response.success && response.data) {
          const latestRun = pickLatestRunForProcess(response.data, processType);
          const pendingForProcess = Number(response.data.pending_by_process?.[processType]) || 0;
          this.setState({
            aiPendingErrors: pendingForProcess,
            aiCanComplete: pendingForProcess === 0,
            aiVerificationEnabled: isAiWorkFileScreenEnabled(
              response.data,
              this.state.filestatus,
            ),
            aiLatestRunAction: String(latestRun?.action || ""),
            aiLatestRunNoRecord: isAiLatestRunMissing(latestRun),
            aiLatestRunVerificationStatus: latestRun?.verification_status,
          });
        }
      })
      .catch(() => {});
  };

  handleAiPendingChange = (pendingCount: number, canComplete: boolean, latestRunAction?: string) => {
    this.setState({
      aiPendingErrors: pendingCount,
      aiCanComplete: canComplete,
      ...(latestRunAction !== undefined ? { aiLatestRunAction: latestRunAction } : {}),
    });
  };

  blockCompleteIfResubmitRequired = async (): Promise<boolean> => {
    const fileId = this.props.id || this.props.fileId;
    const processType = resolveProcessTypeForCompleteGate("work-file", this.state.filestatus);
    const applyFallback = (): boolean => {
      if (!this.state.aiVerificationEnabled) {
        return false;
      }
      if (this.state.aiLatestRunNoRecord) {
        ToastsStore.error(AI_NO_RUN_COMPLETE_MESSAGE);
        return true;
      }
      if (String(this.state.aiLatestRunVerificationStatus).trim() === "0") {
        ToastsStore.error(AI_VERIFICATION_IN_PROGRESS_COMPLETE_MESSAGE);
        return true;
      }
      if (
        isAiVerificationStatusNeedsRerun({
          verification_status: this.state.aiLatestRunVerificationStatus,
          action: this.state.aiLatestRunAction,
        })
      ) {
        ToastsStore.error(AI_RERUN_VERIFICATION_COMPLETE_MESSAGE);
        return true;
      }
      if (isAiRunActionResubmitRequired({ action: this.state.aiLatestRunAction })) {
        ToastsStore.success(AI_RESUBMIT_REQUIRED_COMPLETE_MESSAGE);
        return true;
      }
      if (this.state.aiPendingErrors > 0) {
        ToastsStore.error(
          `Complete ${this.state.aiPendingErrors} open system verification error(s) with remarks before completing the file.`,
        );
        return true;
      }
      return false;
    };
    try {
      const response = await getAiWorkflowStatus(fileId, processType);
      const payload = getAiWorkflowPayload(response);
      if (payload) {
        const latestRun = pickLatestRunForProcess(payload, processType);
        const settingsEnabled = isAiWorkFileScreenEnabled(
          payload,
          this.state.filestatus,
        );
        this.setState({
          aiLatestRunAction: String(latestRun?.action || ""),
          aiVerificationEnabled: settingsEnabled,
          aiLatestRunNoRecord: isAiLatestRunMissing(latestRun),
          aiLatestRunVerificationStatus: latestRun?.verification_status,
          aiPendingErrors: Number(payload.pending_by_process?.[processType]) || 0,
        });
        if (settingsEnabled) {
          const block = getAiCompleteFileBlock(payload, processType);
          if (block) {
            if (block.toastType === "success") {
              ToastsStore.success(block.message);
            } else {
              ToastsStore.error(block.message);
            }
            return true;
          }
        }
        return false;
      }
    } catch (_err) {}
    return applyFallback();
  };

  checkApproveVerify = () => {
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    callApi("POST", "get_approved_status.php", {
      id: this.props.id,
      userId,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response && response.data && response.data.length > 0) {
          this.setState({
            isApprove: Number(response.data[0].is_approved),
            isVerify: Number(response.data[0].is_verified),
          });
        }
      });
  };
  fileVerification = () => {
    callApi("POST", "set_verify.php", {
      id: this.props.id,
      status: this.state.isVerify ? 0 : 1,
    })
      .then((res) => res.data)
      .then((response) => {
        this.checkApproveVerify();
      });
  };
  fileApproval = () => {
    callApi("POST", "set_approve.php", {
      id: this.props.id,
      status: this.state.isApprove ? 0 : 1,
    })
      .then((res) => res.data)
      .then((response) => {
        this.checkApproveVerify();
      });
  };
  actionHandle = (action) => {
    this.setState({ action });
  };
  handleReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  };
  validateReason = () => {
    if (this.state.reason === "") {
      ToastsStore.error("Please Enter Reason");
    } else {
      if (this.state.action === "download") {
        this.downloadDoc();
      } else {
        this.uploadDoc();
      }
    }
  };
  downloadDoc = () => {
    $("#reason-modal").modal("hide");
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const obj = {
      fileid: this.props.id,
      reason: this.state.reason,
      createdBy: userId,
    };
    callApi("POST", "download_log.php", obj)
      .then((res) => res)
      .then((response) => {
        if (response.status === 200) {
          // ToastsStore.success("work file Q & A are saved succesfully")
          ToastsStore.success("Reason saved successfully");
          this.downloadDocs();
          this.clearModal();
        } else {
          ToastsStore.error("Error in storing, Please try again!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  uploadFile = (file: any) => {
    this.setState({ uploadFile: file });
  };
  checkRestriction = async (forRunVerification = false) => {
    const response = await callApi("POST", "check_restriction.php", {
      id: this.props.fileId,
      file_status: 6,
      flag: "complete",
    }).then((res) => res.data);
    if (response.response_Code === 201) {
      let message = response.message || "";
      if (forRunVerification) {
        message = String(message).replace(
          /The file cannot be completed(?: due to)?(?: for)? the following reasons/gi,
          "Verification cannot be executed for the following reasons"
        );
      }
      $("#file_not_complete_modal").modal("show");
      this.setState({ fileNotCompleteMsg: { __html: message } });
      return true;
    }
    return false;
  };

  validateBeforeRunVerification = async (): Promise<boolean> => {
    try {
      const checkRestrict = await this.checkRestriction(true);
      if (checkRestrict) return false;
    } catch (_err) {
      ToastsStore.error("Unable to validate file restrictions. Please try again.");
      return false;
    }
    if (this.state.processChecklistStatus == false) {
      ToastsStore.error(
        "Save and submit the process checklist before running verification"
      );
      return false;
    }
    if (
      this.state.blockdownload == "true" &&
      this.state.fileOpinionType == "1" &&
      this.state.filestatus == "5"
    ) {
      ToastsStore.error("Completed File can't be processed");
      return false;
    }
    return true;
  };
  uploadDoc = async () => {
    const checkRestrict = await this.checkRestriction();
    if (checkRestrict) return;

    this.setState({ isLoading: true });
    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const serverLocalFileName = localStorage.getItem("serverLocalFileName");

    let obj: any = {
      fileId: this.props.id,
      reason:
        this.state.blockdownload === "true" && this.state.fileOpinionType == "1"
          ? this.state.filestatus === "9"
            ? "Recitification Completed"
            : "Typing Completed"
          : this.state.reason,
      createdBy: userId,
      file: this.state.uploadFile.base64.split(",")[1],
      errorTypes: ["1", "2"],
      errorSection: ["1", "2"],
      serverLocalFileName:
        this.state.blockdownload === "true" && this.state.fileOpinionType == "1"
          ? this.state.serverLocalFileName || serverLocalFileName
          : "",
    };
    callApi("POST", "template/tests/upload_log.php", obj)
      .then((res) => res.data)
      .then((response) => {
        if (response.status === 200) {
          if (
            this.state.blockdownload == "true" &&
            this.state.fileOpinionType == "1"
          ) {
            this.completeFlowHandler();
          } else {
            ToastsStore.success("Reason saved successfully");
          }
          $("#reason-modal").modal("hide");
          this.setState({
            isLoading: false,
            isrectificationComplete:
              this.state.blockdownload == "true" ? true : false,
            isComplete: false,
            workFileUploaded: true,
          });
          this.getUpdateReasonData();
          this.clearModal();
        } else {
          ToastsStore.error("Please try again!");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  clearModal = () => {
    this.setState({
      reason: "",
    });
  };
  enableModalHandler = async () => {
    if (await this.blockCompleteIfResubmitRequired()) {
      return;
    }
    if (
      this.state.aiVerificationEnabled &&
      this.state.aiPendingErrors > 0
    ) {
      ToastsStore.error(
        `Complete ${this.state.aiPendingErrors} open system verification error(s) with remarks before completing the file.`,
      );
      return;
    }
    if (this.state.processChecklistStatus == false) {
      ToastsStore.error(
        "Save and submit the process checklist before completing the file"
      );
    } else
      if (
        this.state.blockdownload == "true" &&
        this.state.fileOpinionType == "1"
      ) {
        // this.completeFlowHandler();
        if (this.state.filestatus != "5") {
          this.uploadDoc();
        } else {
          ToastsStore.error("Completed File can't be processed");
        }
      } else {
        $("#complete-process").modal("show");
      }
  };
  close = async () => {
    $("#processComplete").modal("hide");
    await this.getOutTime();
  };

  getOutTime = async () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime));
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    } else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
    await this.processEod();
  };

  processEod = () => {
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    const outtime: any = localStorage.getItem("outtimeGet");
    const outdate: any = localStorage.getItem("OutDateGet");
    const secondsSpent = moment(outtime, "HH:mm").diff(
      moment(intime, "HH:mm"),
      "seconds",
    );
    let updatedRemainingTime: any = localStorage.getItem(
      "updatedRemainingTime",
    );
    let updatedtime = Math.round(updatedRemainingTime);
    const status: any = localStorage.getItem("dashboard_status");
    const insertId: any = localStorage.getItem("ProcessEodInsertID");
    let obj = {
      file_id: JSON.parse(fileid1),
      user_id: JSON.parse(userid1),
      in_reason: JSON.parse(inreason),
      out_reason: "Completed",
      intime: JSON.parse(intime),
      outtime: JSON.parse(outtime),
      insert_date: JSON.parse(outdate),
      total_seconds: secondsSpent,
      balance_min: updatedtime,
      dashboard_status: status,
      insert_id: insertId,
    };
    callApi("POST", "process_eod_insert.php", obj)
      .then((res) => res.data)
      .then((response) => {
        localStorage.removeItem("updatedRemainingTime");
        localStorage.removeItem("in_reason");
        localStorage.removeItem("outreason");
        localStorage.removeItem("IntimeGet");
        localStorage.removeItem("OutDateGet");
        $("#out_reason").modal("hide");
        $("#another-reason").modal("hide");
        // ToastsStore.success("Your Reason Saved Successfully");
        localStorage.removeItem("currentfileId");
        localStorage.removeItem("query_raised_status");
        localStorage.removeItem("file_completed_status");
        const path = localStorage.getItem("url") || "/inprogress-file";
        setTimeout(() => {
          this.props.history.push(path);
        }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  overviewtime(type) {
    const loginuser: any = localStorage.getItem("user1");
    var now = new Date();
    var date = now.toLocaleDateString();
    var time = now.toLocaleTimeString();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const currenttime = `${hours}:${minutes}:${seconds}`;
    const currentdate = moment(date).format("YYYY-MM-DD");
    let obj;
    if (type == "Typing Completed") {
      obj = {
        id: this.props.id,
        typingcompleted_time: currenttime,
        typingcompleted_date: currentdate,
        typingcompleted_by: JSON.parse(loginuser),
        reason: "Typing Completed",
        created_by: JSON.parse(loginuser),
        color: "#edada0",
      };
    } else {
      obj = {
        id: this.props.id,
        reason: "Rectification Completed",
        created_by: JSON.parse(loginuser),
        color: "rgb(128 222 251)",
      };
    }
    callApi("POST", "time_update.php", obj)
      .then((res) => res.data)
      .then((response) => { });
  }
  countdownTimerRef: CountdownTimer | null = null;
  completeFlowHandler = async () => {
    this.setState({ showTitle: true });

    if (await this.blockCompleteIfResubmitRequired()) {
      this.setState({ showTitle: false });
      return;
    }

    if (
      this.state.aiVerificationEnabled &&
      this.state.aiPendingErrors > 0
    ) {
      ToastsStore.error(
        `Complete ${this.state.aiPendingErrors} open system verification error(s) with remarks before completing the file.`,
      );
      return;
    }

    const user: any = localStorage.getItem("user");
    const userId = user ? JSON.parse(user)["userId"] : "";
    const report_to = user ? JSON.parse(user)["report_to"] : "";

    const { blockdownload, filestatus, isrectificationComplete } = this.state;

    if (blockdownload === "false") {
      if (filestatus == "9" && isrectificationComplete) {
        $("#complete-process").modal("show");
        return;
      }
    }
    // file status 6 => move to "files to be verfied"
    let status = filestatus == "9" ? 5 : 6;

    callApi("POST", "file_status.php", {
      id: this.props.fileId,
      file_status: status,
      userId: userId,
    })
      .then((res) => res.data)
      .then((response: any) => {
        // query status is 0 - query completed, is 1 - query not completed.
        if (response.response_Code == 200) {
          this.setState({ showTitle: false, isrectificationComplete: false });
          if (response.response_Code === 200) {
            localStorage.setItem("file_completed_status", JSON.stringify(true));
            if (this.countdownTimerRef) {
              this.countdownTimerRef.clearInterval();
            }
            if (this.state.filestatus != "9") {
              if (Number(response.moved_to_final_approval || 0) !== 1) {
                this.overviewtime("Typing Completed");
              }
            } else {
              this.overviewtime("Rectification");
            }
            $("#processComplete").modal("show");
            const user: any = localStorage.getItem("user");
            const userId = user ? JSON.parse(user)["userId"] : "";
            const userName = user ? JSON.parse(user)["firstName"] : "";
            const notifyData = {
              title: `${this.props.fileId}Typing Completed By ${userName}`,
              notifyType: "message",
              updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
            };
            pushnotificationApi(notifyData, userId);
            const branchManger: any = localStorage.getItem("branch_manager");
            const branch_Manager = JSON.parse(branchManger);
            const queryOfficer: any = localStorage.getItem("Query_officer");
            const query_ooficer = JSON.parse(queryOfficer);
            const Scan_officer: any = localStorage.getItem("scan_officer");
            const sacanofficer = JSON.parse(Scan_officer);
            const process_mennager: any =
              localStorage.getItem("process_manager");
            const processManager = JSON.parse(process_mennager);
            if (Array.isArray(branch_Manager) && branch_Manager.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                branch_Manager,
              );
              const branchManager = branch_Manager.join(",");
              let obj = {
                notification_type: "typingcomplete",
                user_id: branchManager,
                ...notifyData,
                reason: `${this.props.fileId}Typing Completed`,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            if (Array.isArray(query_ooficer) && query_ooficer.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "notify" },
                query_ooficer,
              );
              const OfficerQuery = query_ooficer.join(",");
              let obj = {
                notification_type: "typingcomplete",
                user_id: OfficerQuery,
                ...notifyData,
                reason: `${this.props.fileId}Typing Completed`,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
            // if (Array.isArray(sacanofficer) && sacanofficer.length > 0) {
            //   notifyToUser("user", { ...notifyData, notifyType: "message" }, sacanofficer);
            // }
            if (Array.isArray(processManager) && processManager.length > 0) {
              notifyToUser(
                "user",
                { ...notifyData, notifyType: "message" },
                processManager,
              );
              const ProcessManager = processManager.join(",");
              let obj = {
                notification_type: "typingcomplete",
                user_id: ProcessManager,
                ...notifyData,
                reason: `${this.props.fileId}Typing Completed`,
              };
              callApi("POST", "pushnotification.php", obj)
                .then((res) => res.data)
                .then((response) => { })
                .catch((err) => {
                  console.log(err);
                });
            }
          } else {
            ToastsStore.error(
              "Error in completing the file , Please try again!",
            );
          }
        } else if (response.response_Code === 201) {
          $("#file_not_complete_modal").modal("show");
          this.setState({
            fileNotCompleteMsg: { __html: response.message },
          });
        } else {
          ToastsStore.error(response.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  render() {
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";
    const {
      action,
      reason,
      uploadFile,
      lastUploadedDocument,
      timer,
      isComplete,
      showTitle,
      aiPendingErrors,
      aiVerificationEnabled,
      generationTimedOut,
      generationError,
    } = this.state;
    const aiCompleteBlocked =
      aiVerificationEnabled && aiPendingErrors > 0;
    const aiCompleteBlockedMessage = aiCompleteBlocked
      ? "Close all system verification errors before completing"
      : null;
    return this.state.report ? (
      <>
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <TabKeyBlocker scopeToContainer={true}>
          {this.props.isFinal ? (
            <>
              {this.state.isapproved ? (
                <>
                  <a
                    className="btn btn-primary"
                    href={API_ENDPOINT + "api/print.php?id=" + this.props.id}
                    target="_blank"
                  >
                    Download
                  </a>
                  <a
                    className="btn btn-primary md-trigger"
                    data-toggle="modal"
                    href="#myModal"
                  >
                    Mail To Users
                  </a>
                </>
              ) : (
                <>
                  <button
                    className="btn btn-primary"
                    style={{ cursor: "not-allowed" }}
                    disabled={true}
                  >
                    Download
                  </button>
                  <button
                    className="btn btn-primary"
                    style={{ cursor: "not-allowed" }}
                    disabled={true}
                  >
                    Mail To Users
                  </button>
                </>
              )}
              {(role_id === MANAGER_ROLE || role_id === ADMIN_ROLE) && (
                <button
                  className={
                    this.state.isapproved ? "btn btn-danger" : "btn btn-success"
                  }
                  onClick={this.approveFile}
                >
                  {this.state.isapproved ? "Rework" : "Approve"}
                </button>
              )}
              {this.state.isapproved ? (
                <a
                  className="btn btn-primary"
                  href={API_ENDPOINT + "api/print.php?id=" + this.props.id}
                  target="_blank"
                >
                  Vetting Report
                </a>
              ) : (
                ""
              )}
              {/* <a
              className="btn btn-primary"
              href="https://www.ilovepdf.com/pdf_to_word"
              target="_blank"
            >
              PDF To Word Conversion
            </a> */}
            </>
          ) : (
            <>
              {/* <button className="btn btn-danger" onClick={this.resetOverview}>
              Reset
            </button> */}
              {/* <a
                className="btn btn-warning md-trigger"
                data-toggle="modal"
                href="#confirmReset"
              >
                Reset
            </a> */}

              {/* <button
                className="btn btn-warning"
                disabled={this.state.enableRefresh}
                onClick={this.getFileOverview}
              >
                Refresh
              </button>
              <button
                className="btn btn-primary"
                onClick={() => this.saveReport(-1)}
              >
                Save
            </button>
              <button
                className="btn btn-success"
                onClick={() => this.saveReport(0)}
              >
                Save & Submit
            </button>
              <button disabled={this.state.isVerify}
                className="btn btn-success"
                onClick={this.fileVerification}
              >
                Verify
            </button> */}
              {/* <button disabled={!this.state.isVerify}
                className={this.state.isApprove ? "btn btn-danger" : "btn btn-success"}
                onClick={this.fileApproval}
              >
                {this.state.isApprove ? 'Reject' : 'Approve'}
              </button> */}
              {this.state.blockdownload == "false" ||
                this.state.fileOpinionType != "1" ? (
                <>
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => this.actionHandle("download")}
                    data-toggle="modal"
                    data-target="#reason-modal"
                    style={{ fontWeight: "bold", borderWidth: "2px" }}
                  >
                    Download Doc <i className="fa fa-download" />
                  </button>
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => this.actionHandle("upload")}
                    data-toggle="modal"
                    data-target="#reason-modal"
                    style={{ fontWeight: "bold", borderWidth: "2px" }}
                  >
                    Upload Doc <i className="fa fa-upload" />
                  </button>
                </>
              ) : (
                <>
                  {/* {(role_id === ADMIN_ROLE) ? (
                    <>
                      <button
                        className="btn btn-outline-dark"
                        onClick={() => this.actionHandle("download")}
                        data-toggle="modal"
                        data-target="#reason-modal"
                        style={{ fontWeight: "bold", borderWidth: "2px" }}
                      >
                        Download Doc <i className="fa fa-download" />
                      </button>
                      <button
                        className="btn btn-outline-dark"
                        onClick={() => this.actionHandle("upload")}
                        data-toggle="modal"
                        data-target="#reason-modal"
                        style={{ fontWeight: "bold", borderWidth: "2px" }}
                      >
                        Upload Doc <i className="fa fa-upload" />
                      </button>
                    </>
                  ) : ""
                  } */}
                </>
              )}
              <button
                className="btn btn-outline-dark"
                onClick={() =>
                  this.props.history.push("/work-file-qa/" + this.props.id)
                }
                style={{ fontWeight: "bold", borderWidth: "2px" }}
              >
                Work File Q&amp;A
              </button>
              <button
                className="btn btn-outline-dark"
                onClick={() => {
                  // Navigate to work-file-details with state indicating we're coming from step4
                  const finalapprovalprocesscheck = {
                    fromCheckPage: true,
                    previousStep: "step4",
                  };
                  localStorage.setItem(
                    "finalapprovalprocesscheck",
                    JSON.stringify(finalapprovalprocesscheck),
                  );
                  localStorage.removeItem("verififinalapprove");

                  this.props.history.push({
                    pathname: `/work-file-details/${this.props.id}`,
                    state: {
                      fromCheckPage: true,
                      previousStep: "step4", // Store which step we came from
                    },
                  });
                }}
                style={{ fontWeight: "bold", borderWidth: "2px" }}
              >
                Check
              </button>
              <button
                className="btn btn-outline-dark"
                onClick={() =>
                  this.props.history.push(
                    "/work-file-process-checklist/" + this.props.id,
                  )
                }
                style={{ fontWeight: "bold", borderWidth: "2px" }}
              >
                CheckList
              </button>
              {/* <Link
                to={"/work-file-details/" + this.props.id}
                className="btn btn-primary"
                style={{ float: "right" }}
              >
                Check
              </Link>
              <Link
                to={"/work-file-qa/" + this.props.id}
                className="btn btn-primary"
                style={{ float: "right" }}
              >
                Work File Q&amp;A
              </Link> */}
              {isComplete && (
                <div className="ai-complete-action-wrap">
                  {aiCompleteBlockedMessage ? (
                    <span className="ai-action-block-msg" role="status">
                      {aiCompleteBlockedMessage}
                    </span>
                  ) : null}
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginTop: "0px" }}
                    onClick={this.enableModalHandler}
                    disabled={aiCompleteBlocked}
                    title={aiCompleteBlockedMessage || ""}
                  >
                    Complete
                  </button>
                </div>
              )}

              {!isComplete && (
                <div className="ai-complete-action-wrap">
                  {aiCompleteBlockedMessage ? (
                    <span className="ai-action-block-msg" role="status">
                      {aiCompleteBlockedMessage}
                    </span>
                  ) : null}
                  <button
                    onClick={() => this.completeFlowHandler()}
                    type="button"
                    className="btn btn-primary"
                    style={{ marginTop: "0px" }}
                    disabled={aiCompleteBlocked}
                    title={aiCompleteBlockedMessage || ""}
                  >
                    Complete
                  </button>
                </div>
              )}
              {/* <button
              className="btn btn-primary"
             
              style={{ float: "right" }}
            >
              Complete
            </button> */}
            </>
          )}
        </TabKeyBlocker>

        {!this.props.isFinal && this.state.aiVerificationEnabled && (
          <div className="ai-verification-overview-top">
            <DocumentVerificationPanel
              fileId={this.props.id}
              filestatus={this.state.filestatus}
              context="work-file"
              takenStatus={this.state.takenStatus}
              vtakenStatus={this.state.vtakenStatus}
              rtakenStatus={this.state.rtakenStatus}
              blockDownloadStatus={this.state.blockdownload}
              fileOpinionType={this.state.fileOpinionType}
              documentUrl={this.state.documentEmbedUrl || this.state.report}
              documentPath={this.state.documentDocPath}
              workFileDocumentUrl={this.getWorkFileDocxUrl()}
              hasWorkFileUpload={this.hasWorkFileDocumentForVerification()}
              localFileName={this.state.serverLocalFileName}
              processChecklistStatus={this.state.processChecklistStatus}
              onBeforeRunVerification={this.validateBeforeRunVerification}
              onPendingChange={this.handleAiPendingChange}
            />
          </div>
        )}

        {/* <div
          id="report-content"
          contentEditable={!this.props.isFinal}
          dangerouslySetInnerHTML={{ __html: this.state.report }}
         /> */}
        <div className="modal" id="reason-modal">
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-header">
                {action === "download" ? (
                  <h5 className="modal-title">Reason For Download</h5>
                ) : (
                  <h5 className="modal-title">Reason For Upload</h5>
                )}
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div>
                  {action === "download" ? (
                    <label>Enter Reason*</label>
                  ) : (
                    <React.Fragment>
                      <label>Enter Updated Informations*</label>
                      <ReactFileReader
                        fileTypes={[".doc", ".docx"]}
                        base64={true}
                        // multipleFiles={true}
                        handleFiles={(e) => this.uploadFile(e)}
                      >
                        <button
                          className="ml2 btn btn-success btnupload"
                        // disabled={this.state.isFlowChartUploading}
                        >
                          {/* {this.state.isFlowChartUploading ? (
                                          <i className="fa fa-spinner fa-spin"></i>
                                      ) : <i className="icon feather icon-upload" />} */}
                          Select File
                        </button>
                      </ReactFileReader>
                      <span>{uploadFile.fileList[0].name}</span>
                    </React.Fragment>
                  )}
                  <textarea
                    className="form-control mt-10"
                    name="reason"
                    value={reason}
                    onChange={this.handleReasonChange}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn " data-dismiss="modal">
                  Cancel
                </button>
                {action === "download" ? (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.validateReason}
                  >
                    Download
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.validateReason}
                    disabled={this.state.isLoading}
                  >
                    {this.state.isLoading ? (
                      <i className="fa fa-spinner fa-spin"></i>
                    ) : (
                      "Upload"
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "10px" }} />
        {this.props.isFinal ? (
          <PDFViewer
            document={{
              url:
                API_ENDPOINT +
                "api/doc_securty/" +
                "LAW-" +
                this.state.realFileidfk +
                ".pdf",
            }}
          />
        ) : (
          // <iframe
          //   width="100%"
          //   height="600"
          //   frameBorder="0"
          //   src={this.state.report}
          // ></iframe>
          <div className="iframe-container">
            <iframe
              src={this.state.report}
              width="100%"
              height="500"
              frameBorder="0"
            >
              This is an embedded Word document.
            </iframe>
            <div className="top-overlay"></div>
            <div className="bottom-overlay"></div>
          </div>
        )}
        <div className="modal" id="myModal">
          <div>
            <ToastsContainer
              store={ToastsStore}
              position={ToastsContainerPosition.TOP_RIGHT}
            />
          </div>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Send Mail</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      {this.state.office_users && this.state.office_users.length
                        ? this.state.office_users.map((user: any, index) => {
                          return (
                            <div
                              className="custom-control custom-checkbox"
                              key={index}
                            >
                              <input
                                type="checkbox"
                                className=""
                                onChange={(e) => this.selectUser(e, user)}
                              />
                              <label className="">
                                {user.name + " - " + user.email}
                              </label>
                            </div>
                          );
                        })
                        : ""}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group" />
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-info"
                  data-dismiss="modal"
                  onClick={this.sendMail}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="modal" id="confirmReset">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm Reset</h4>
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <p> Are you sure you want to reset document?</p>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-info"
                  data-dismiss="modal"
                  onClick={this.resetOverview}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal hide fade in"
          id="processComplete"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div className="modal-body">
                <h5 style={{ textAlign: "center" }}>
                  {" "}
                  Thanks For Complete Your File:{this.props.id}
                </h5>
              </div>
              <div className="modal-footer">
                {showTitle ? null : (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => this.close()}
                    // onClick={this.disableModalHandler}
                    style={{ width: "50%", fontSize: "17px", margin: "auto" }}
                  >
                    {" "}
                    Ok
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal hide fade in"
          id="queryStatusModel"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div className="modal-body">
                <h5 style={{ textAlign: "center" }}>
                  {" "}
                  Please Complete All The Queries Before Typing Completed For
                  This File :{this.props.id}
                </h5>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-dismiss="modal"
                  style={{ width: "50%", fontSize: "17px", margin: "auto" }}
                >
                  {" "}
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal hide fade in"
          id="file_not_complete_modal"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog ">
            <div
              className="modal-content"
              style={{ borderRadius: "10px", boxShadow: "0 0 15px #000" }}
            >
              <div className="modal-body">
                <h5
                  style={{ textAlign: "left" }}
                  dangerouslySetInnerHTML={this.state.fileNotCompleteMsg}
                ></h5>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  data-dismiss="modal"
                  style={{ width: "50%", fontSize: "17px", margin: "auto" }}
                >
                  {" "}
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* This is for modal */}
        <div className="modal" id="complete-process">
          <div className="modal-dialog ">
            <div className="modal-content">
              <div className="modal-body">
                <h3>Without upload document you can't complete the file</h3>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                // onClick={this.disableModalHandler}
                >
                  {" "}
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      // <CircularProgress style={{ marginLeft: '50%' }} />
      <div className="text-center" style={{ padding: "40px 16px" }}>
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        {generationTimedOut ? (
          <>
            <h4 style={{ color: "#c0392b", marginBottom: 12 }}>
              {generationError || "Document generation failed."}
            </h4>
            {!isDocGenWorkerDownError(generationError) ? (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.retryDocumentGeneration}
              >
                Retry
              </button>
            ) : null}
          </>
        ) : (
          <h4>
            <span>Loading... {timer} seconds</span>
          </h4>
        )}
      </div>
    );
  }
}
